/*
 * @Description: 通用弹窗组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-10-24 13:49:10
 */
import React, { forwardRef, useImperativeHandle } from 'react'
import { Modal } from 'antd'
import './index.scss'

interface CommonModalProps {
  open: boolean
  onCancel: () => void
  onOk?: () => void
  title?: string
  content?: string
  buttonText?: string
  backgroundImage?: string
  width?: number
  className?: string
}

export interface CommonModalRef {
  handleButtonClick: () => void
}

const CommonModal = forwardRef<CommonModalRef, CommonModalProps>(
  (
    {
      open,
      onCancel,
      onOk,
      title,
      content,
      buttonText = '我知道了',
      backgroundImage,
      width = 318,
      className = ''
    },
    ref
  ) => {
    const handleOk = () => {
      if (onOk) {
        onOk()
      } else {
        onCancel()
      }
    }

    // 暴露给外部的方法
    useImperativeHandle(ref, () => ({
      handleButtonClick: handleOk
    }))

    return (
      <Modal
        title={null}
        open={open}
        onCancel={onCancel}
        footer={null}
        centered
        width={width}
        closable={false}
        mask={{ closable: false }}
        styles={{
          body: { padding: 0, background: 'transparent', border: 'none' },
          content: {
            background: 'transparent',
            boxShadow: 'none',
            border: 'none',
            padding: 0
          },
          mask: {}
        }}
        style={{
          background: 'transparent',
          border: 'none',
          boxShadow: 'none'
        }}
        wrapClassName="common-modal-wrapper custom-modal"
      >
        <div
          className={`modal-content ${backgroundImage ? 'has-bg-image' : ''}`}
        >
          {backgroundImage && (
            <img
              src={backgroundImage}
              alt="背景图"
              className="modal-bg-image"
            />
          )}
          <div className="modal-content-overlay">
            {title && <div className="modal-title">{title}</div>}
            {content && <div className="modal-message">{content}</div>}
            <button className="modal-button" onClick={handleOk}>
              {buttonText}
            </button>
          </div>
        </div>
      </Modal>
    )
  }
)

CommonModal.displayName = 'CommonModal'
export default CommonModal
